<template>
<v-card>
<v-toolbar flat color="red" height="42">
  <v-toolbar-title style="color:white">
Удаление аккаунтов
  </v-toolbar-title>
<v-spacer/>
<v-icon @click="accounts.modals.deleteAccounts = false" color="white">mdi-close</v-icon>
</v-toolbar>

<v-card-text>
<h6 style="color:gray">Подтвердите удаление аккаунтов.
Отменить данную операцию будет невозможно.
</h6>

<div v-for="item in toDelete" :key="item.value">
<v-switch v-model="item.is" class="mt-0" color="green" hide-details >
<span style="margin-top:6px" slot="label">{{item.text}}</span>
</v-switch>
</div>

<v-checkbox color="#242F3B"  hide-details v-model="deleteFromAllgr">
<span slot="label" style="margin-top:6px;font-size:.9em">Удалить во всех группах</span>
</v-checkbox>
</v-card-text>
<v-card-actions>
<v-spacer/>
<v-btn @click="accounts.modals.deleteAccounts = false"   small flat color="#242F3B" style="text-transform:none"  >  Отмена</v-btn>
<v-btn :disabled="disabled" :loading = "loading" @click="deleteAccounts()"   small color="red" style="text-transform:none" class="white--text"> <v-icon left>mdi-delete</v-icon> Удалить аккаунты</v-btn>
</v-card-actions>


</v-card>
</template>

<script>
import axios from 'axios'
export default {
props: ['accounts'],
data () {
return {
disabled:false,
loading:false,
deleteFromAllgr:false,
toDelete:[
{
is:true,
text:"Невалидные",
value:"invalid"
},
{
is:false,
text:"Выбранные",
value:"selected"
},
{
is:false,
text:"Все аккаунты",
value:"all"
},
],
}
},
methods: {

deleteAccounts(){
this.disabled = true
this.loading = true
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/delete_accounts.php', {
method: 'POST',
data:{
deleteFromAllgr:this.deleteFromAllgr,
toDelete:this.toDelete,
accounts:this.accounts
}
}).then(response => {
this.$router.go()

})
},


},
computed:{
},
mounted(){
},

}
</script>

<style    >

</style>
